import { MouseEventHandler } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../../hooks/useTranslation";
import { FormatNumber, FormatPrice } from "../../../utils/generalUtils";
import { Minus } from "../../Icons";
import BrandImage, { ComponentPropsType as BrandImageType } from "../BrandImage";
import style from "./index.module.css";
import noImagePlaceholder from "../../../assets/images/romotors-no-image-available-notext.jpg";

const SingleVehicleCard = ({
  card_style = '',
  brand,
  link,
  image,
  model,
  year,
  has_discount,
  old_price,
  price,
  has_free_maintenance,
  isWishlistPage = false,
  removeWishList,
  selling_flag,
}: ComponentPropsType) => {
  const { locale } = useTranslation();

  return (
    <div className={style.vehicle}>
      <BrandImage {...brand} feature={selling_flag || ""} featureLink={link} />
      <div className={style.vehicle_image}>
        <Link to={link}>
          <img className={style[card_style]} src={image || noImagePlaceholder} alt="" />
        </Link>
        {isWishlistPage && removeWishList && (
          <button className={style.vehicle_unwishlist} title={locale("remove_wishlist")} onClick={removeWishList}>
            <Minus width="20" height="20" color="#dc0000" />
          </button>
        )}
      </div>
      <div className={style.vehicle_details}>
        <div className={style.vehicle_details__col}>
          <p>
            {locale("model")}: <b>{model}</b>
          </p>
          <p>
            {locale("year")}:{" "}
            <b>
              <FormatNumber value={year} />
            </b>
          </p>
        </div>
        <div className={style.vehicle_details__col}>
          {has_discount === 0 ? (
            has_free_maintenance === 1 ? (
              <>
                <p className={`${style.price}`}>
                  {+price === 0 ? <p>{locale("currentlyUnavailableNewVehicle")}</p> : <FormatPrice value={price} />}
                </p>
                <p className={style.note}>{locale("free_maintenance")}</p>
              </>
            ) : (
              <>
                <p className={style.note}>{locale("price")}</p>
                <p className={`${style.price}`}>
                  {+price === 0 ? (
                    <span>{locale("currentlyUnavailableNewVehicle")}</span>
                  ) : (
                    <FormatPrice value={price} />
                  )}
                </p>
              </>
            )
          ) : (
            <>
              <p className={`${style.price} ${style.old_price}`}>
                <FormatPrice value={old_price} />
              </p>
              <p className={`${style.price} ${style.new_price}`}>
                {+price === 0 ? <span>{locale("currentlyUnavailableNewVehicle")}</span> : <FormatPrice value={price} />}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleVehicleCard;

type ComponentPropsType = {
  card_style?: string;
  brand: BrandImageType;
  image: string;
  link: string;
  model: string;
  year: string;
  price: string;
  has_discount: 0 | 1;
  old_price: string;
  has_free_maintenance: 0 | 1;
  isWishlistPage?: boolean;
  removeWishList?: MouseEventHandler<HTMLButtonElement>;
  selling_flag?: string;
};
